import { DefaultTask } from "./default-task.model";
import { Observable } from "rxjs/Observable";
import { Qry } from "../query-facade";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import * as actions from "./default-task.actions";
import { AccountObjectStoreFacade } from "../account-object/account-object.store-facade";
import { VasState } from "../../store/store-type";
import { IDefaultTaskFilters } from "./default-task.reducer";
import { DefaultTaskType } from "../defaultTask-type/defaultTask-type.model";
import { TaskType } from "../task-type/task-type.model";
import { Transition } from "../transition/transition.model";
import { intersect } from "../../../core/util/utils";
import { isInArray } from "../../../core/util/is-in-array";
import { removeFromArray } from "../../../core/util/remove-from-array";

export class DefaultTaskStoreFacade extends AccountObjectStoreFacade<DefaultTask> {

    getAll(): Observable<Array<DefaultTask>> {
        return this.select(Qry.getInstance().defaultTask.byActiveAccount);
    }

    getFiltered(): Observable<Array<DefaultTask>> {
        return this.select(Qry.getInstance().defaultTask.filtered);
    }

    create(defaultTask: DefaultTask): void {
        this.submit(defaultTask);
    }

    update(defaultTask: DefaultTask): void {
        this.submit(defaultTask);
    }

    protected submit(defaultTask: DefaultTask): void {

        let transitions: Array<Transition> = [];
        this.appFacade.objects.transition.store.getAll()
            .take(1)
            .subscribe(_transitions => transitions = _transitions);

        // ensure that the defaultTask does not contain any ids that do not exist (yet)
        defaultTask = new DefaultTask({
            ...defaultTask,
            transitions: intersect(defaultTask.transitions, transitions.map(transition => transition.id))
        });

        this.dispatch(new actions.SubmitAction(defaultTask));

        // ensure that the defaultTask's id is added to all transitions it references
        transitions
            .filter(transition => isInArray(transition.id, defaultTask.transitions))
            .forEach(transition => {
                this.appFacade.objects.transition.store.attachDefaultTask(transition, defaultTask);
            });

        // remove the defaultTask's id from any transition is does not reference
        transitions
            .filter(transition => !isInArray(transition.id, defaultTask.transitions))
            .forEach(transition => {
                this.appFacade.objects.transition.store.detachDefaultTask(transition, defaultTask);
            });
    }

    insert(defaultTask: DefaultTask): void {
        this.dispatch(new actions.SubmitAction(defaultTask, {persistable: true, restful: false}));
    }

    remove(defaultTask: DefaultTask, options?: ActionOptionsArgs): void {
        this.dispatch(new actions.RemoveAction(defaultTask, options));
    }

    attachTransition(defaultTask: DefaultTask, transition: Transition): void {

        if (isInArray(transition.id, defaultTask.transitions)) {
            return;
        }

        defaultTask = new DefaultTask({
            ...defaultTask,
            transitions: [...defaultTask.transitions, transition.id]
        });

        this.submit(defaultTask);
    }

    detachTransition(defaultTask: DefaultTask, transition: Transition): void {

        if (!isInArray(transition.id, defaultTask.transitions)) {
            return;
        }

        defaultTask = new DefaultTask({
            ...defaultTask,
            transitions: removeFromArray(defaultTask.transitions, transition.id)
        });

        this.submit(defaultTask);
    }

    removeByTaskType(taskType: TaskType, options?: ActionOptionsArgs): void {
        this.removeBy(defaultTask => defaultTask.taskType === taskType.id, options);
    }

    setFilters(filters): void {
        this.dispatch(new actions.SetFilterAction(filters));
    }

    setTotal(total: number): void {
        this.dispatch(new actions.SetTotalAction(total));
    }

    getTotal(): Observable<number> {
        return this.select((state: VasState) => state.defaultTask.total);
    }

    loadNextPage(): void {
        return this.dispatch(new actions.LoadNextPage());
    }

    canLoadMore(): Observable<boolean> {
        return this.select((state: VasState) => state.defaultTask.total !== state.defaultTask.ids.length);
    }

    getFilters(): Observable<IDefaultTaskFilters> {
        return this.select((state: VasState) => {
            return state.defaultTask.filters;
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/default-task/default-task.store-facade.ts